import { api } from "#app/http/api";

export const deleteProduct = async (id: string): Promise<boolean> => {
  const response = await api.products.delete.mutation({
    params: { id },
  });

  return response.status === 200;
};
